import React from "react";
import propertyNotFoundImg from "../../assets/components/PropertiesCardList/no-properties-found.png";

type LazyPropertyImageProps = {
  src: string;
  alt: string;
  className?: string;
  onClick?: () => void;
  loading?: "lazy" | "eager";
};

export function handlePropertyImageError(
  event: React.SyntheticEvent<HTMLImageElement, Event>
) {
  const image = event.currentTarget;
  const currentSrc = image.getAttribute("src");

  if (!currentSrc || image.dataset.fallbackApplied === "true") {
    return;
  }

  image.dataset.fallbackApplied = "true";
  image.src = propertyNotFoundImg;
}

export default function LazyPropertyImage({
  src,
  alt,
  className,
  onClick,
  loading = "lazy",
}: LazyPropertyImageProps) {
  return (
    <img
      className={className}
      alt={alt}
      onClick={onClick}
      loading={loading}
      src={src}
      onError={handlePropertyImageError}
    />
  );
}
